import { Component, Input } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { shareReplay } from 'rxjs';

interface CallingCode { region: string; name: string; code: string }
let callingCodes$: ReturnType<typeof loadCodes> | undefined;
function loadCodes() {
  return http$.get<CallingCode[]>('/App/GetCountryCallingCodes').pipe(shareReplay(1));
}

@Component({
  selector: 'lib-country-code-field',
  standalone: true,
  host: { class: 'block min-w-0' },
  imports: [AsyncPipe],
  template: `
    <label class="flex flex-col gap-1 text-sm">
      Country Code
      <select class="h-10 w-full min-w-0 border rounded px-2 bg-transparent" [value]="control.value ?? ''"
        (change)="control.setValue($any($event.target).value || null)">
        <option value="">Select country code</option>
        @for (country of codes$ | async; track country.region) {
          <option [value]="country.code" [selected]="control.value === country.code">{{ country.name }} ({{ country.code }})</option>
        }
      </select>
    </label>
  `,
})
export class CountryCodeFieldComponent {
  @Input({ required: true }) control!: { value: string | null | undefined; setValue(value: string | null): void };
  readonly codes$ = callingCodes$ ??= loadCodes();
}
